import { IRootState } from 'app/shared/reducers';
import { createSelector } from 'reselect';
import { AuthenticationState, initialState } from './state';

const selectAuthState = (state: IRootState) => state.authentication;

export const getAccount = createSelector<IRootState, AuthenticationState, any>(
  selectAuthState,
  (state: AuthenticationState) => state.account
);

export const getAccountEmail = createSelector<IRootState, AuthenticationState, any>(
  selectAuthState,
  (state: AuthenticationState) => state.account.email
);

export const getSellingPointInfo = createSelector<IRootState, AuthenticationState, any>(selectAuthState,(anthentification: AuthenticationState) => ({
iban : `${anthentification?.sellingPointModel?.details[0]?.bankInfos.iban || ''}`
}));


